import React, { useState } from "react";
import { Link } from "react-router-dom";

const DAILY_CARE_LOG_PATH = "/daily-care-log";

const formatNoteTimestamp = (timestamp) => {
  if (timestamp && timestamp.toDate) {
    return timestamp.toDate().toLocaleString();
  }
  return "N/A";
};

const RecentNotes = ({ notes }) => {
  const [showAll, setShowAll] = useState(false);

  if (!notes || notes.length === 0) {
    return (
      <div className="rounded-2xl bg-slate-50 p-4 text-center">
        <p className="text-sm text-slate-500">No recent notes to display.</p>
        <p className="mt-1 text-xs text-slate-400">
          Showing notes created in the past 30 days.
        </p>
        <Link
          to={DAILY_CARE_LOG_PATH}
          className="mt-3 inline-block text-sm font-semibold text-blue-600 hover:text-blue-700"
        >
          Add Daily Care Log →
        </Link>
      </div>
    );
  }

  const visibleNotes = showAll ? notes : notes.slice(0, 2);
  const hasMore = notes.length > 2;

  return (
    <div>
      <p className="mb-3 text-xs text-slate-500">
        Showing notes created in the past 30 days.
      </p>
      <ul className="grid grid-cols-1 gap-3" style={{ gridAutoRows: "1fr" }}>
        {visibleNotes.map((note) => (
          <li key={note.id}>
            <Link
              to={DAILY_CARE_LOG_PATH}
              className="flex h-full flex-col justify-between rounded-2xl border border-amber-100 bg-amber-50/70 p-4 transition hover:bg-white hover:shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              <div>
                <p className="font-semibold text-slate-950 break-words">
                  {note.noteText}
                </p>
              </div>
              <p className="text-sm text-slate-500 mt-2">
                Created on {formatNoteTimestamp(note.createdAt)}
              </p>
            </Link>
          </li>
        ))}
      </ul>
      <div className="mt-4 flex items-center justify-between gap-3">
        {hasMore ? (
          <button
            onClick={() => setShowAll(!showAll)}
            className="text-sm font-semibold text-blue-600 hover:text-blue-700"
          >
            {showAll ? "Show Less" : `View All (${notes.length}) →`}
          </button>
        ) : (
          <div /> /* Spacer */
        )}
        <Link
          to={DAILY_CARE_LOG_PATH}
          className="text-sm font-semibold text-blue-600 hover:text-blue-700"
        >
          Open Daily Care Log →
        </Link>
      </div>
    </div>
  );
};

export default RecentNotes;
